module.exports = __webpack_public_path__ + "static/media/8.f63d8fc0.jpeg";